import React from 'react';
import ReactDOM from 'react-dom';

import Iconset from './icons';

import '../styles/wifi_view.scss';
import '../styles/inline_fallback.scss';

import '../styles/twitter_fallback.scss';
import '../styles/instagram_fallback.scss';

class InstagramFallback extends React.Component{

	render(){
		return (<div className="wifi-view twitter_fallback">
			<div className="wifi-view-holder">
				<div className="logo-icon">
					<Iconset.logo />
				</div>
				<div className="wifi-view-block">
					<div className="ico cellular">
						<Iconset.sadSmiley />
					</div>
					<p>The Instagram in-app browser doesn’t support the Blossomentary. Please open in your standard browser.</p>
					<a target="_blank" href="http://blossomentary.milkychance.net" className="instagram-fallback-link" >blossomentary.milkychance.net</a>
				</div>
			</div>
		</div>);
	}
}

export default InstagramFallback;


// WEBPACK FOOTER //
// ./src/scripts/instagram_fallback.js